/* eslint-disable @typescript-eslint/no-empty-function */
import { createContext } from 'react';

export interface IInventoryContext {
  isNestedCard: boolean;
  setIsNestedCard: (value: boolean) => void;
  openInventoryActionCard: boolean;
  setOpenInventoryCard: (value: boolean) => void;
  openInventoryCard: boolean;
  setOpenInventoryActionCard: (value: boolean) => void;
  openInventoryTransferCard: boolean;
  setOpenInventoryTransferCard: (value: boolean) => void;
  openInventoryWriteOffCard: boolean;
  setOpenInventoryWriteOffCard: (value: boolean) => void;
  openInventoryAssigneeCard: boolean;
  setOpenInventoryAssigneeCard: (value: boolean) => void;
}

export const InventoryContext = createContext<IInventoryContext>({
  isNestedCard: false,
  setIsNestedCard: () => {},
  openInventoryCard: false,
  setOpenInventoryCard: () => {},
  openInventoryActionCard: false,
  setOpenInventoryActionCard: () => {},
  openInventoryTransferCard: false,
  setOpenInventoryTransferCard: () => {},
  openInventoryWriteOffCard: false,
  setOpenInventoryWriteOffCard: () => {},
  openInventoryAssigneeCard: false,
  setOpenInventoryAssigneeCard: () => {},
});
